module.exports = __webpack_public_path__ + "static/media/pencil-and-ruler.8350425e.svg";